import { compose, lifecycle, withState, mapProps } from 'recompose';
import { connect } from 'react-redux';
import { omit } from 'lodash';

import withLoading from '../../../common/withLoading';
import { fetchAutoPayoutSuggestionStatus as fetchAutoPayoutEligibilityStatus }
  from '../../suggestAutoPayoutModal/actions';
import { getActiveShopId, getActiveType } from '../../../auth/selectors';

export default compose(
  connect(state => ({
    shopId: getActiveShopId(state),
    isShopViewActive: getActiveType(state) === 'shop',
  })),
  withState('showLoading', 'setShowLoading', true),
  withState('autoPayoutEligibilityStatus', 'setAutoPayoutEligibilityStatus', {}),
  lifecycle({
    componentDidMount() {
      if (!this.props.isShopViewActive) {
        this.props.setShowLoading(false);
        return;
      }

      fetchAutoPayoutEligibilityStatus(this.props.shopId).then((status) => {
        this.props.setAutoPayoutEligibilityStatus(status);
        this.props.setShowLoading(false);
      });
    },
  }),
  withLoading,
  mapProps(props =>
    omit(props, ['showLoading', 'setShowLoading', 'setAutoPayoutEligibilityStatus', 'shopId']))
);
